// src/components/Dashboard.jsx
import React, { useEffect, useState } from 'react'
import { useDashboard } from '../../contexts/DashboardContext'
import Loader from '../Utils/Loader'
import ProgramList from './Programs/ProgramList'
import TopicList from './Topics/TopicList'
import QualificationList from './Qualifications/QualificationList'
import PersonList from './People/PersonList'
import LiveProgramSlider from './Live/LiveProgramSlider'
import AccountList from './Accounts/AccountList'
import RubricaList from './Rubrica/RubricaList'
import '../../css/dashboard.css'

const Dashboard = () => {
  const {
    programs,
    topics,
    qualifications,
    people,
    companies,
    schedules,
    rubrica,
    isLoading,
    fetchAllData,
    isAdmin,
  } = useDashboard()

  const [activeTab, setActiveTab] = useState('live')
  const [programListKey, setProgramListKey] = useState(0)

  useEffect(() => {
    fetchAllData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const forceRemountProgramList = () => {
    setProgramListKey(Date.now())
  }

  const renderActiveTab = () => {
    switch (activeTab) {
      case 'live':
        return (
          <LiveProgramSlider
            programs={programs}
            schedules={schedules}
            people={people}
            topics={topics}
          />
        )
      case 'programmi':
        return (
          <ProgramList
            key={programListKey}
            programs={programs}
            schedules={schedules}
            refreshProgramsList={fetchAllData}
            peopleList={people}
            topicList={topics}
            companyList={companies}
            rubricaList={rubrica}
            onForceRemount={forceRemountProgramList}
          />
        )
      case 'argomenti':
        return <TopicList topics={topics} refreshTopicsList={fetchAllData} />
      case 'qualifiche':
        return (
          <QualificationList
            qualifications={qualifications}
            refreshQualificationsList={fetchAllData}
          />
        )
      case 'persone':
        return (
          <PersonList
            people={people}
            refreshPeopleList={fetchAllData}
            qualifications={qualifications}
          />
        )
      case 'rubriche':
        return (
          <RubricaList
            rubrica={rubrica}
            refreshRubricaList={fetchAllData}
          />
        )
      case 'accounts':
        return <AccountList refreshTrigger={programListKey /* o un altro trigger */} />
      default:
        return null
    }
  }

  // definisco le tab base
  const tabs = ['live', 'programmi', 'argomenti', 'qualifiche', 'persone', 'rubriche']
  // aggiungo 'accounts' solo se admin
  if (isAdmin()) {
    tabs.push('accounts')
  }

  if (isLoading) {
    return (
      <div className="dashboard-content">
        <div className="dashboard-tabs">
          {tabs.map(tab => (
            <div
              key={tab}
              className={`dashboard-tab ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab.charAt(0).toUpperCase() + tab.slice(1)}
            </div>
          ))}
        </div>
        <Loader />
      </div>
    )
  }

  return (
    <div className="dashboard-content">
      <div className="dashboard-tabs">
        {tabs.map(tab => (
          <div
            key={tab}
            className={`dashboard-tab ${activeTab === tab ? 'active' : ''}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab.charAt(0).toUpperCase() + tab.slice(1)}
          </div>
        ))}
      </div>
      {renderActiveTab()}
    </div>
  )
}

export default Dashboard
